import {NodeCodeChunk} from "../../chunks/types/NodeCodeChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getCodeNameFromNodeCodeChunk(
  nodeCodeChunk: NodeCodeChunk
): string | null {
  const {
    captures: {
      2: builtinNameChunk,
      3: customNameChunk
    }
  } = nodeCodeChunk;
  if (builtinNameChunk) {
    return builtinNameChunk.captures[0];
  } else if (customNameChunk) {
    return getNameFromIdentifierChunk(customNameChunk);
  } else {
    return null;
  }
}
